import React, { useContext, useEffect } from 'react'

import {
  filterAnalyticsTag,
  filterAnalyticsSatellite,
} from '../helpers/InvestmentProductsHelper.js'

import { ProductContext } from '../ProductContext.jsx'

export default function MutualFundsFilter({
  selectedClass,
  ignoreClass,
  onClose,
  onMorningstarChange,
  onBenchmarkChange,
  onMorningStarGroupChange,
  lookupCategory,
  section,
  isETF,
}) {
  const {
    types,
    setTypes,
    categories,
    setCategories,
    managementStyles,
    setManagementStyles,
    setSelectedGoals,
  } = useContext(ProductContext)

  let isQueryStringApplied = false
  let analyticsStr = ''

  useEffect(() => {
    initializeQueryStringFilter()
  }, [selectedClass])

  const initializeQueryStringFilter = () => {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search)

      if (!isQueryStringApplied) {
        if (urlParams.get('featured-funds')) {
          onChangeTypeCheckbox({
            target: { value: 'featureFund', checked: true },
          })
        }

        if (urlParams.get('top-performing-funds')) {
          onChangeTypeCheckbox({
            target: { value: 'manyStars', checked: true },
          })
        }

        if (urlParams.get('multi-managed-funds')) {
          onChangeTypeCheckbox({
            target: { value: 'multiManager', checked: true },
          })
        }

        if (urlParams.get('group-by-category')) {
          onMorningstarChange({
            currentTarget: {
              checked: true,
            },
          })
          onMorningStarGroupChange({
            currentTarget: {
              checked: true,
            },
          })
        }

        if (urlParams.get('primarybenchmark')) {
          onBenchmarkChange({
            currentTarget: {
              checked: true,
            },
          })
        }

        isQueryStringApplied = true
      }

      if (selectedClass) {
        const invcategories = urlParams.getAll('investment-category')

        const invCategoryIds = invcategories.map((category) => {
          const investmentCategory = selectedClass.investmentCategories.find(
            (c) => lookupCategory(c.categoryName) === category
          )
          if (investmentCategory) {
            return investmentCategory.styleId
          }
        })
        setCategories(invCategoryIds)
      }
    }
  }

  const getFundClassFilterDescription = (name) => {
    switch (name) {
      case 'featureFund':
        return 'Featured Mutual Funds'
      case 'multiManager':
        return 'Multi-Manager Funds'
      case 'manyStars':
        return '4 & 5 Star Funds'
    }
  }

  const arrayAddRemove = (arr, val, isChecked) => {
    const array = [...arr]
    const indexOfEntry = array.indexOf(val)
    if (indexOfEntry > -1) {
      if (!isChecked) {
        array.splice(indexOfEntry, 1)
      }
    } else {
      if (isChecked) {
        array.push(val)
      }
    }
    return array
  }

  const onChangeTypeCheckbox = (event) => {
    const payload = arrayAddRemove(
      types,
      event.target.value,
      event.target.checked
    )
    setTypes(payload)
  }

  const onChangeCategoryCheckbox = (event) => {
    const payload = arrayAddRemove(
      categories,
      event.target.value,
      event.target.checked
    )
    setCategories(payload)
  }

  const onChangeManagementStyleCheckbox = (event) => {
    const payload = arrayAddRemove(
      managementStyles,
      event.target.value,
      event.target.checked
    )
    setManagementStyles(payload)
  }

  const onClickViewResults = () => {
    analyticsStr = ''
    // Filter by category names for analytics
    selectedClass &&
      selectedClass.filterInfo.length > 0 &&
      getTypes().map((fundClassFilter) => {
        if (types.includes(fundClassFilter.filterName)) {
          analyticsStr = analyticsStr.concat(
            getFundClassFilterDescription(fundClassFilter.filterName),
            ';'
          )
        }
      })
    // Index investment category names from IDs
    selectedClass &&
      selectedClass.filterInfo.length > 0 &&
      selectedClass.investmentCategories.map((assetClass) => {
        if (categories.includes(assetClass.styleId)) {
          analyticsStr = analyticsStr.concat(assetClass.categoryName, ';')
        }
      })
    // Management Styles for analytics
    selectedClass &&
      selectedClass.managementStyles &&
      selectedClass.managementStyles.map((style) => {
        if (managementStyles.includes(style.code)) {
          analyticsStr = analyticsStr.concat(style.code, ';')
        }
      })
    filterAnalyticsSatellite(analyticsStr, window.location.pathname)
    onClose && onClose()
  }

  const onClickClearFilters = () => {
    setTypes([])
    setCategories([])
    setSelectedGoals([])
    setManagementStyles([])
  }

  const getTypes = () => {
    const info = selectedClass.filterInfo
      .filter(
        (fundClassFilter) => fundClassFilter.filterName !== 'investorGoal'
      )
      .sort((a, b) => (a.filterName || '').localeCompare(b.filterName || ''))

    info.splice(1, 0, {
      filterName: 'manyStars',
      filterValues: [{ code: 'manyStars' }],
    })

    return info
  }

  return (
    <>
      <div className="Grid Grid--withGutter u-paddingVert1gu u-paddingHoriz7gu">
        <div
          className={`${isETF ? 'u-size4of12' : 'u-size6of12'} u-sm-sizeFull`}
        >
          <div className="u-textSizeMsrp1 u-textBold MutualFunds-filterTitle u-textColorBrandDark">
            Asset Class
          </div>
          <div>
            {selectedClass && selectedClass.investmentCategories.length > 0
              ? selectedClass.investmentCategories.map((investmentCategory) => {
                  return (
                    <div
                      key={`${investmentCategory.styleId}-${section}`}
                      className="u-flex u-flexAlignItemsCenter"
                    >
                      <div className="Checkbox">
                        <input
                          type="checkbox"
                          id={
                            'investmentCategory-' +
                            investmentCategory.styleId
                              .toString()
                              .replace(/[\s|/]/g, '_') +
                            '-Checkbox-' +
                            section
                          }
                          data-qa-automation={
                            'investmentCategory-' +
                            investmentCategory.styleId
                              .toString()
                              .replace(/[\s|/]/g, '_') +
                            '-Checkbox-' +
                            section
                          }
                          className="Checkbox-button u-posRelative"
                          checked={
                            categories.indexOf(
                              investmentCategory.styleId.toString()
                            ) > -1
                          }
                          value={investmentCategory.styleId}
                          onChange={onChangeCategoryCheckbox}
                          data-analytics={filterAnalyticsTag(
                            window.location.pathname
                          )}
                        />
                        <label
                          htmlFor={
                            'investmentCategory-' +
                            investmentCategory.styleId
                              .toString()
                              .replace(/[\s|/]/g, '_') +
                            '-Checkbox-' +
                            section
                          }
                          className="Checkbox-label u-margin0"
                        >
                          <div className="u-textNoWrap">
                            {investmentCategory.categoryName}
                          </div>
                        </label>
                      </div>
                    </div>
                  )
                })
              : null}
          </div>
        </div>
        {ignoreClass && (
          <div className="u-size4of12 u-sm-sizeFull">
            <div className="u-textSizeMsrp1 u-textBold u-textNoWrap MutualFunds-filterTitle u-sm-marginTop6gu u-textColorBrandDark">
              Management Style
            </div>
            <div>
              {selectedClass &&
                selectedClass.managementStyles &&
                selectedClass.managementStyles.map((style) => {
                  return (
                    <div key={`${style.code}-${section}`} className="Checkbox">
                      <input
                        type="checkbox"
                        id={`managementStyle${style.code}-Checkbox-${section}`}
                        data-qa-automation={`managementStyle${style.code}-Checkbox-${section}`}
                        className="Checkbox-button u-posRelative"
                        checked={managementStyles.indexOf(style.code) > -1}
                        value={style.code}
                        onChange={onChangeManagementStyleCheckbox}
                        data-analytics={filterAnalyticsTag(
                          window.location.pathname
                        )}
                      />
                      <label
                        htmlFor={`managementStyle${style.code}-Checkbox-${section}`}
                        className="Checkbox-label u-margin0"
                      >
                        <div>{style.code}</div>
                      </label>
                    </div>
                  )
                })}
            </div>
          </div>
        )}
        <div
          className={`${isETF ? 'u-size4of12' : 'u-size6of12'} u-sm-sizeFull`}
        >
          <div className="u-textSizeMsrp1 u-textBold u-textNoWrap MutualFunds-filterTitle u-sm-marginTop6gu u-textColorBrandDark">
            {ignoreClass ? 'Morningstar Rating' : 'Other Filters'}
          </div>
          <div>
            {selectedClass && selectedClass.filterInfo.length > 0
              ? getTypes().map((fundClassFilter) => {
                  return (
                    <div
                      key={`${fundClassFilter.filterValues[0].code}-${section}`}
                      className="Checkbox"
                    >
                      <input
                        type="checkbox"
                        id={
                          'fundClass' +
                          fundClassFilter.filterValues[0].code +
                          'Checkbox-' +
                          section
                        }
                        data-qa-automation={
                          'fundClass' +
                          fundClassFilter.filterValues[0].code +
                          'Checkbox-' +
                          section
                        }
                        className="Checkbox-button u-posRelative"
                        checked={types.indexOf(fundClassFilter.filterName) > -1}
                        value={fundClassFilter.filterName}
                        onChange={onChangeTypeCheckbox}
                        data-analytics={filterAnalyticsTag(
                          window.location.pathname
                        )}
                      />
                      <label
                        htmlFor={
                          'fundClass' +
                          fundClassFilter.filterValues[0].code +
                          'Checkbox-' +
                          section
                        }
                        className="Checkbox-label u-margin0"
                      >
                        <div className="u-textNoWrap">
                          {getFundClassFilterDescription(
                            fundClassFilter.filterName
                          )}
                        </div>
                      </label>
                    </div>
                  )
                })
              : null}
          </div>
        </div>
      </div>
      <div className="u-paddingVert4gu u-paddingHoriz7gu">
        <button
          className="Button Button--primary Button--small"
          data-tracking="view-results"
          onClick={onClickViewResults}
          data-qa-automation={'viewResults'}
        >
          View Results
        </button>
        <button
          className="Button Button--tertiary Button--small u-marginLeft3gu"
          data-tracking="clear-filters"
          onClick={onClickClearFilters}
          data-qa-automation={'clearFilters'}
        >
          Clear Filters
        </button>
      </div>
    </>
  )
}
